import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getUserResources, UserResource } from '../routes';

export function useUserResources(
  userId: string | undefined | null,
  options?: Omit<
    UseQueryOptions<UserResource[], AxiosError<unknown>, UserResource[]>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery({
    queryKey: ['user-resources', userId],
    queryFn: () => getUserResources(userId!),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
